import type { CartConfig } from '#types/config/components/cart'

export default {
  brandClasses: {
    details: 'body-4',
    progress: 'bg-gradient-to-r from-[#bf7c2e] to-[#7f531f]',
    threshold: 'subtitle-6 c-brand-1'
  },
  showIcon: true
} satisfies CartConfig['shippingProgress']
